import { type ComponentType } from "react"

import { usePlatform } from "~/contexts/PlatformContext"
import { useUser } from "~/contexts/UserContext"
import {
	BundleIcon,
	CalendarIcon,
	CertificateIcon,
	CommunityIcon,
	CourseIcon,
	DownloadIcon,
	HomeIcon,
	MembershipIcon,
	MessageIcon,
	ClockIcon,
	UsersIcon,
	VideoIcon,
} from "~/themes/original/components/Icon"
import { hasAccessToViewCommunity } from "~/utilities/community"
import routes from "~/utilities/routes"

type NavigationItem = { label: string; onClick: string; icon: ComponentType }
export default function useNavigationItems(): NavigationItem[] {
	const platform = usePlatform().platform
	const user = useUser().user

	const items: NavigationItem[] = [{ label: "Dashboard", onClick: routes.dashboard.index(), icon: HomeIcon }]

	if (platform.content.courses) {
		items.push({ label: "Courses", onClick: routes.course.index(), icon: CourseIcon })
	}
	if (platform.content.videos) {
		items.push({ label: "Videos", onClick: routes.video.index(), icon: VideoIcon })
	}
	if (platform.content.downloadables) {
		items.push({ label: "Downloadables", onClick: routes.downloadable.index(), icon: DownloadIcon })
	}
	if (platform.content.bundles) {
		items.push({ label: "Bundles", onClick: routes.bundle.index(), icon: BundleIcon })
	}
	if (platform.content.sessions) {
		items.push({ label: "Sessions", onClick: routes.session.index(), icon: ClockIcon })
	}
	if (platform.content.events) {
		items.push({ label: "Events", onClick: routes.event.index(), icon: CalendarIcon })
	}
	if (platform.content.certificates) {
		items.push({ label: "Certificates", onClick: routes.certificate.index(), icon: CertificateIcon })
	}
	if (user !== null && platform.community !== null && hasAccessToViewCommunity(user, platform.community)) {
		items.push({ label: "Community", onClick: routes.community.index(), icon: CommunityIcon })
		if (platform.community.isGamificationEnabled) {
			items.push({ label: "Leaderboard", onClick: routes.community.leaderboard(), icon: UsersIcon })
		}
		items.push({ label: "Messages", onClick: routes.community.conversations(), icon: MessageIcon })
	}
	if (platform.content.memberships) {
		items.push({ label: "Membership", onClick: routes.membership.index(), icon: MembershipIcon })
	}

	return items
}
